import { Component, inject } from "@angular/core";
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatSidenavModule } from "@angular/material/sidenav";
import { ITileInstance } from "../../../dashboards/interfaces/tiles/definition-helpers/tile-definition.interface";
import { TileInstanceControl } from "../../../tile/component/instance.control";
import { TileCreatorService } from "../../services/tile-creator.service";
import { TILE_REQUEST } from "../../tokens/tile-request.token";
import { TileSetupWizardComponent } from "../tile-setup-wizard.component";

@Component({
  selector: 'dynamic-tile-widget',
  standalone:true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatSidenavModule,
    MatExpansionModule,
    TileInstanceControl,
  ],
  template: `
    <form [formGroup]="setupForm">
      <tile-instance-control formControlName="configuration" [selectedName]="tileInstance.tileType"/>
      <div class="footer">
        <button mat-flat-button color="primary" (click)="onCreate()">Apply</button>
      </div>
    </form>
  `
})
export class DynamicTileWidget extends TileSetupWizardComponent<ITileInstance> {
  constructor(
    private readonly tileCreatorService: TileCreatorService,
  ) {
    super();
    this.tileInstance = inject(TILE_REQUEST).tileInstance;
    this.setupForm.reset();
    this.setupForm.patchValue(this.tileInstance);
    this.hookForm();
  }

  setupForm: FormGroup<any> = new FormGroup({
    configuration: new FormControl<{} | null>(null),
  });

  getChanges() {
    return this.setupForm.getRawValue();
  }

  onCreate() {
    Object.assign(this.tileInstance, this.getChanges());
    this.tileCreatorService.onChange.next();
  }
}
